import { configureStore } from "./configureStore";

export const store = configureStore();

if (!store) {
    console.error("Undefined store");
}
